<template>
	<div class="form">
		<h4 class="step-title">Homeowner?</h4>
		<div class="step-content d-flex flex-column align-items-center">
			<scrollable-button-list
				v-bind:items="homeOwner"
				v-bind:onclick="complete"
				v-bind:value="lead.homeInsurance.homeOwner"
			/>
		</div>
	</div>
</template>

<script>
import ScrollableButtonList from "../shared/ScrollableButtonList.vue";

export default {
	name: "HomeOwner",
	components: {
		ScrollableButtonList,
	},
	data: function () {
		return {
			homeOwner: [
				{ text: "Own", value: "Own" },
				{ text: "Rent", value: "Rent" },
			],
		};
	},
	props: {
		lead: Object,
	},
	methods: {
		complete: function (value) {
			this.lead.homeInsurance.homeOwner = value;
			this.$emit("complete", this.$options.name, value);
		},
	},
};
</script>
